/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryOff = createReactComponent("outline", "battery-off", "IconBatteryOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M11 7h6a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1", "key": "svg-1" }]]);

export { IconBatteryOff as default };
//# sourceMappingURL=IconBatteryOff.mjs.map
